// extracted by mini-css-extract-plugin
export default {"container":"SetupFiltersSection_container__UCe6K"};